export default __webpack_public_path__ + "static/media/team-header-logo-min.061c5dd0.svg";